/* Stendos Horizon cart visual countdown; does not reserve inventory. */
(() => {
  const KEY = 'stendosCartVisualCountdownEnd';
  let end = 0;
  const readEnd = () => {
    if (end) return end;
    try { end = Number(sessionStorage.getItem(KEY)) || 0; } catch (_) {}
    if (!end || end < Date.now()) {
      end = Date.now() + 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (_) {}
    }
    return end;
  };
  const update = () => {
    const nodes = document.querySelectorAll('#cart-drawer [data-stendos-cart-countdown]');
    if (!nodes.length) return;
    const seconds = Math.max(0, Math.ceil((readEnd() - Date.now()) / 1000));
    const label = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    nodes.forEach(node => { if (node.textContent !== label) node.textContent = label; });
  };
  update();
  setInterval(update, 1000);
  document.addEventListener('DOMContentLoaded', update);
  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true });
})();